import React, { useContext } from 'react'
import Box from '../../box'
import TextField from '../../textfield'
import { LocationStepContext } from './location_step_context'

const LocationStep: React.FC = () => {
  const {
    data: formData,
    setStepData: setStepFormData
  } = useContext(LocationStepContext)

  const { address, apt, city, state, zipcode } = formData

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target
    setStepFormData({
      ...formData as any,
      [name]: value
    })
  }

  return (
    <Box>
      <TextField
        name = 'address'
        value = {address}
        onChange = {onInputChange}
        label="Street Address"
        placeholder="Enter your street address"
        fullWidth
        gutterBottom
      />
      <TextField
        fullWidth
        name = 'apt'
        value = {apt}
        onChange = {onInputChange}
        label="Apt, Suite, etc."
        placeholder="Enter your apt, suite, etc."
      />
      <Box display={'flex'} gap={1}>
        <TextField
          name = 'city'
          value = {city}
          onChange = {onInputChange}
          label="City"
          placeholder="Enter your city"
          fullWidth
          gutterBottom
        />
        <TextField
          name = 'state'
          value = {state}
          onChange = {onInputChange}
          label="State"
          placeholder="Enter your state"
          fullWidth
          gutterBottom
        />
        <TextField
          name = 'zipcode'
          value = {zipcode}
          onChange = {onInputChange}
          label="Zip Code"
          placeholder="Enter your zip code"
          fullWidth
          gutterBottom
        />
      </Box>
    </Box>
  )
}

export default LocationStep
